export default "__VITE_ASSET__CObQwo6i__"